import React, {useCallback, useEffect, useState} from 'react'

import FieldToggle_Component from "./toggle-stateless"
import FieldProto from "../../../../proto/field-proto"

export enum ToggleSize {
    SIZE_16 = '16',
    SIZE_18 = '18',
    SIZE_20 = '20',
    SIZE_24 = '24'
}

type Props = {
    className?      : string
    field           : FieldProto,
    isDisabled?     : boolean,
    value           : boolean,
    size            : ToggleSize

    onChange?       : callback,
}

const debug = false
// const debug = "FieldToggle_ComponentStatefull"

export default function FieldToggle_ComponentStatefull(props: Props) {

    const [value, setValue] = useState(props.value)

    useEffect(() => {
        setValue(props.value)
    }, [props.value])

    const onClick = useCallback(() => {
        debug && console.log(debug, 'onClick', props.isDisabled, !value)

        if (props.isDisabled) return

        const newValue = !value
        setValue(newValue)

        if (props.onChange) props.onChange(newValue)
    }, [props.value, value])

    const onClickThrottle = useCallback(_.throttle(onClick, 500), [props.value, value]);

    debug && console.log(debug, 'render', value, props.value)

    return (
        <div className={Classes("ui5-field-form-editable transparent-bg no-border min-h-36", props.className, {
            'p-l-10': !props.className?.includes('p-l-'),
            'p-r-10': !props.className?.includes('p-r-')
        })}>
            <FieldToggle_Component className    = "no-margin"
                                   size         = {props.size}
                                   value        = {value}
                                   disabled     = {props.isDisabled}
                                   onClick      = {onClickThrottle}/>
        </div>
    )
}

FieldToggle_ComponentStatefull.defaultProps = {
    size: ToggleSize.SIZE_20
}